import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import React, { useEffect, useState, useMemo } from 'react';
import { shape, string } from 'prop-types';
import StereoHeaderDesktop from '@magalu/stereo-ui/templates/HeaderDesktop';
import { usePublisher } from '@magalu/mixer-publisher';
import { useCart, useLocation, useSuggestions, useTopTerms, useWishlist } from '@magalu/mixer-graphql';
import { adaptUseTopTermsToStereoHeaderProps, routePush, setLocationCookies, slug, isZipcodeInvalid, useStorage } from '@magalu/mixer-utils';
import { parseHeaderLinksSuggestions } from '../../../commons';
import { termToUrl } from '@magalu/mixer-structure';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { Container } from './HeaderDesktop.styles';
import renderCustomLoginMenu from './renderCustomLoginMenu';
import adaptMixerToStereoHeaderProps from './adaptMixerToStereoHeaderProps';
import adaptUseSuggestionsToStereoHeaderProps from './adaptUseSuggestionsToStereoHeaderProps';
var HEADER_SELECT_CONTENT = 'header:selectContent';
var HEADER_IMPRESSION = 'header:impression';
function HeaderDesktop(_ref) {
  var _structure$route3;
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure,
    config = _ref.config;
  var _ref2 = structure.cookies || {},
    partnerId = _ref2.partnerId,
    cartId = _ref2.cartId,
    customerId = _ref2.customerId,
    toggleWishlist = _ref2.toggleWishlist,
    accountData = _ref2.accountData,
    _ref2$location = _ref2.location,
    location = _ref2$location === void 0 ? {} : _ref2$location;
  var _useState = useState(adaptMixerToStereoHeaderProps({
      config: config,
      data: data,
      location: location,
      staticProps: staticProps,
      structure: structure
    })),
    _useState2 = _slicedToArray(_useState, 2),
    headerProps = _useState2[0],
    setHeaderProps = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    bagCount = _useState4[0],
    setBagCount = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    wishlistCount = _useState6[0],
    setWishlistCount = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    chosenSuggestion = _useState8[0],
    setChosenSuggestion = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showTopTerms = _useState10[0],
    setShowTopTerms = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isRendered = _useState12[0],
    setIsRendered = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isHoverZipcode = _useState14[0],
    seIsHoverZipcode = _useState14[1];
  var searchUrl = staticProps.searchUrl,
    headerData = staticProps.headerData,
    wishlistUrl = staticProps.wishlistUrl,
    wishlistSpa = staticProps.wishlistSpa,
    cartUrl = staticProps.cartUrl,
    menuData = staticProps.menuData,
    linksSuggestionsData = staticProps.linksSuggestionsData,
    customLoginMenu = staticProps.customLoginMenu;
  var _ref3 = (menuData == null ? void 0 : menuData.data) || {},
    _ref3$wishListIconPro = _ref3.wishListIconProps,
    wishListIconProps = _ref3$wishListIconPro === void 0 ? {} : _ref3$wishListIconPro,
    _ref3$bagIconProps = _ref3.bagIconProps,
    bagIconProps = _ref3$bagIconProps === void 0 ? {} : _ref3$bagIconProps;
  var _ref4 = structure.route || {},
    _ref4$term = _ref4.term,
    initialQuery = _ref4$term === void 0 ? '' : _ref4$term;
  var _useState15 = useState(initialQuery),
    _useState16 = _slicedToArray(_useState15, 2),
    currentTerm = _useState16[0],
    setCurrentTerm = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    showZipcodePopper = _useState18[0],
    setShowZipcodePopper = _useState18[1];
  var showWishlistCount = toggleWishlist;
  var _useState19 = useState(initialQuery),
    _useState20 = _slicedToArray(_useState19, 1),
    term = _useState20[0];
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useSuggestions = useSuggestions({
      partnerId: partnerId
    }),
    suggestions = _useSuggestions.suggestions,
    productsSuggestions = _useSuggestions.productsSuggestions,
    getSuggestions = _useSuggestions.getSuggestions,
    cleanSuggestions = _useSuggestions.cleanSuggestions;
  var _useLocation = useLocation(),
    locationData = _useLocation.location,
    error = _useLocation.error,
    getData = _useLocation.getData;
  var shouldUpdateZipcode = isZipcodeInvalid(location);
  useEffect(_asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!((accountData == null ? void 0 : accountData.zip_code) && !location.zipCode || shouldUpdateZipcode)) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return getData({
            zipCode: shouldUpdateZipcode ? location.zipCode : accountData.zip_code
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  useEffect(function () {
    setHeaderProps(adaptMixerToStereoHeaderProps({
      config: config,
      data: data,
      location: location,
      staticProps: staticProps,
      structure: structure
    }));
  }, [JSON.stringify(location)]);
  useEffect(function () {
    if (!error && locationData.location && (!location.zipCode || shouldUpdateZipcode)) {
      var zipCode = shouldUpdateZipcode ? location.zipCode : accountData.zip_code;
      var updatedLocation = {
        zipCode: zipCode,
        zipCodeCity: locationData.location.city,
        zipCodeState: locationData.location.state
      };
      setLocationCookies(locationData.location, zipCode, structure, config);
      setHeaderProps(adaptMixerToStereoHeaderProps({
        config: config,
        data: data,
        location: updatedLocation,
        staticProps: staticProps,
        structure: structure
      }));
      publish('zipcode:auto', updatedLocation);
    }
  }, [error, JSON.stringify(locationData.location)]);
  var _useTopTerms = useTopTerms(),
    _useTopTerms$topTerms = _useTopTerms.topTerms,
    _useTopTerms$topTerms2 = _useTopTerms$topTerms.label,
    topTermsLabel = _useTopTerms$topTerms2 === void 0 ? '' : _useTopTerms$topTerms2,
    _useTopTerms$topTerms3 = _useTopTerms$topTerms.terms,
    topTermsList = _useTopTerms$topTerms3 === void 0 ? [] : _useTopTerms$topTerms3;
  var topTermsProps = adaptUseTopTermsToStereoHeaderProps({
    showTopTerms: showTopTerms,
    topTermsLabel: topTermsLabel,
    topTermsList: topTermsList
  });
  var suggestionsProps = adaptUseSuggestionsToStereoHeaderProps({
    products: productsSuggestions,
    terms: suggestions
  });
  var suggestionLinksProps = useMemo(function () {
    return structure.id === 'home' ? parseHeaderLinksSuggestions(linksSuggestionsData) : {};
  }, [structure.id]);
  var _useCart = useCart(),
    _useCart2 = _slicedToArray(_useCart, 1),
    getCart = _useCart2[0].getCart;
  var _useWishlist = useWishlist(),
    getWishlist = _useWishlist.getWishlist;
  var handleWishlistChange = function () {
    var _ref6 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
      var _yield$getWishlist, wishlistData, wishlistError, _wishlistData$wishlis, hashId, storage, quantity;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (showWishlistCount) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return getWishlist(customerId);
          case 4:
            _yield$getWishlist = _context2.sent;
            wishlistData = _yield$getWishlist.data;
            wishlistError = _yield$getWishlist.error;
            if (!wishlistError) {
              hashId = customerId.slice(-4);
              storage = useStorage('wishlist', hashId);
              storage.set(wishlistData.wishlist.items);
              quantity = wishlistData == null ? void 0 : (_wishlistData$wishlis = wishlistData.wishlist) == null ? void 0 : _wishlistData$wishlis.count;
              setWishlistCount(quantity);
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleWishlistChange() {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleCartChange = function () {
    var _ref7 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var _yield$getCart, cartData, cartError, _cartData$cart, _cartData$cart$totals, quantity;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getCart(cartId, customerId);
          case 2:
            _yield$getCart = _context3.sent;
            cartData = _yield$getCart.data;
            cartError = _yield$getCart.error;
            if (!cartError) {
              quantity = parseInt((cartData == null ? void 0 : (_cartData$cart = cartData.cart) == null ? void 0 : (_cartData$cart$totals = _cartData$cart.totals) == null ? void 0 : _cartData$cart$totals.itemsQuantity) || 0, 10);
              setBagCount(quantity);
            }
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleCartChange() {
      return _ref7.apply(this, arguments);
    };
  }();
  var publishSuggestionFromRoute = function publishSuggestionFromRoute(suggestion) {
    var position = suggestions.findIndex(function (item) {
      return item.term === suggestion;
    }) + 1;
    publish('suggestion:click', {
      position: position,
      term: suggestion
    });
  };
  var handleZipcodeSuccess = function handleZipcodeSuccess() {
    publish('zipcodebar:popup:success');
    setShowZipcodePopper('success');
  };
  useEffect(function () {
    if (showZipcodePopper) {
      publish('zipcodebar:popup:view');
    }
  }, [showZipcodePopper]);
  useEffect(function () {
    if (cartId || customerId) {
      handleCartChange();
    }
    handleWishlistChange();
  }, []);
  useEffect(function () {
    if (suggestionLinksProps && structure.id === 'home') {
      publish('link-suggestions:impression', suggestionLinksProps);
    }
  }, [suggestionLinksProps]);
  useEffect(function () {
    subscribe('product:wishlist:click', handleWishlistChange);
    return function () {
      unsubscribe('product:wishlist:click', handleWishlistChange);
    };
  }, []);
  useEffect(function () {
    subscribe('zipcodebar:response:success', handleZipcodeSuccess);
    return function () {
      unsubscribe('zipcodebar:response:success', handleZipcodeSuccess);
    };
  });
  useEffect(function () {
    var _structure$route;
    if (chosenSuggestion && chosenSuggestion.includes(structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term)) {
      var _structure$route2;
      publishSuggestionFromRoute(structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term);
    }
  }, [structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term, chosenSuggestion]);
  useEffect(function () {
    return setTimeout(function () {
      return setShowZipcodePopper(headerProps.initialZipcodePopper);
    }, 2000);
  }, [headerProps]);
  useEffect(function () {
    setTimeout(function () {
      setIsRendered(true);
    }, 1000);
  }, []);
  var handleWishlistIconClick = function handleWishlistIconClick(e) {
    e.preventDefault();
    routePush({
      path: wishlistUrl,
      spa: wishlistSpa
    });
  };
  var onLogoClick = function onLogoClick(e) {
    e.preventDefault();
    routePush({
      path: headerData.logo.url,
      spa: headerData.logo.spa
    });
  };
  var handleSuggest = function handleSuggest(suggestionsTerm, productsSize) {
    getSuggestions({
      productsSize: productsSize,
      term: suggestionsTerm
    });
  };
  var handleSuggestDebounced = debounce(function (suggestion) {
    return handleSuggest(suggestion, 5);
  }, 500);
  var handleSuggestThrottled = throttle(function (suggestion) {
    var productsSize = suggestion.endsWith(' ') ? 5 : 0;
    return handleSuggest(suggestion, productsSize);
  }, 500);
  var handleSuggestionClick = function handleSuggestionClick(suggestion) {
    setChosenSuggestion(suggestion);
  };
  var handleTopTermItemClick = function handleTopTermItemClick(topTerm) {
    setShowTopTerms(false);
    var position = topTerm.index,
      clickedTopTerm = topTerm.term;
    publish('suggestion:topterm:click', {
      position: position,
      term: clickedTopTerm
    });
  };
  var handleProductItemClick = function handleProductItemClick(e, product) {
    e.preventDefault();
    var id = product.id,
      path = product.path;
    var position = productsSuggestions.findIndex(function (item) {
      return item.variationId === id;
    }) + 1;
    publish('suggestion-product:click', {
      position: position,
      variationId: id
    });
    routePush({
      path: path,
      spa: headerData.suggestions.spa
    });
  };
  var handleSearch = function handleSearch(e, newTerm) {
    e.preventDefault();
    var newTermTrim = newTerm.trim();
    if (e.type === 'submit' && newTermTrim) {
      publish('search:submit', {
        term: newTermTrim
      });
    }
    var replacedTerm = newTermTrim.replace(/[*=_#%¨()|\\/|!:@]/g, ' ');
    var termStr = replacedTerm && "".concat(termToUrl(slug(replacedTerm)), "/");
    var newTermUrl = "".concat(searchUrl.replace(/\/?$/, '/')).concat(termStr);
    routePush({
      path: newTermUrl,
      spa: true
    });
  };
  var handleTypeSearch = function handleTypeSearch(newTerm) {
    setCurrentTerm(newTerm);
    if (newTerm.length === 0) {
      cleanSuggestions();
      setShowTopTerms(true);
    }
    if (newTerm.length >= 2) {
      setShowTopTerms(false);
      if (newTerm.length < 5 || newTerm.endsWith(' ')) {
        handleSuggestThrottled(newTerm);
      } else {
        handleSuggestDebounced(newTerm);
      }
    }
  };
  var handleOpenInput = function handleOpenInput() {
    if (currentTerm.trim()) {
      setShowTopTerms(false);
      if (suggestions.length === 0) {
        handleSuggest(term);
      }
    } else {
      setShowTopTerms(true);
    }
  };
  var handlePopperBtn = function handlePopperBtn() {
    setShowZipcodePopper(null);
    publish('zipcodebar:popup:click');
    publish('zipcodeinput:toggle');
  };
  var handleClosePopper = function handleClosePopper() {
    if (showZipcodePopper === 'info') {
      publish('addtorejectzipcode:success');
      publish('zipcodebar:popup:close');
    }
    setShowZipcodePopper(null);
  };
  var handleCloseInput = function handleCloseInput() {
    setShowTopTerms(false);
    publish('search:close', {
      term: term
    });
  };
  var wishlistProps = _extends({
    amount: wishlistCount,
    nullable: showWishlistCount,
    onClick: handleWishlistIconClick
  }, wishListIconProps);
  headerProps.data.wishlist = wishlistProps;
  var handleMenuItemClick = function handleMenuItemClick(e, link, selectedSubmenu, menuType) {
    e.preventDefault();
    publish('product:selectContent', selectedSubmenu, link.label, menuType);
    routePush({
      path: link == null ? void 0 : link.url,
      spa: true
    });
  };
  var handleClickLinks = function handleClickLinks(label) {
    publish(HEADER_SELECT_CONTENT, label);
  };
  var handleClickSearch = function handleClickSearch() {
    publish(HEADER_SELECT_CONTENT, currentTerm, 'search');
  };
  var handleUnsignedClick = function handleUnsignedClick() {
    publish(HEADER_SELECT_CONTENT, 'cadastro');
  };
  var handleSignedHover = function handleSignedHover() {
    publish(HEADER_IMPRESSION, 'login');
  };
  var handleClickLinkSuggestion = function handleClickLinkSuggestion(e, link) {
    e.preventDefault();
    publish('link-suggestions:click', link);
    publish(HEADER_SELECT_CONTENT, link.value, 'suggestion');
    routePush({
      path: link.href,
      spa: true
    });
  };
  var handleZipCodeClick = function handleZipCodeClick() {
    setShowZipcodePopper(null);
    publish(HEADER_SELECT_CONTENT, 'ver-ofertas-para-minha-regiao');
    publish('zipcodeinput:toggle');
  };
  var handleSignedMenuClick = function handleSignedMenuClick(label) {
    publish(HEADER_SELECT_CONTENT, label, 'login');
  };
  var handleHoverZipCode = function handleHoverZipCode() {
    seIsHoverZipcode(true);
    if (!isHoverZipcode) publish(HEADER_IMPRESSION, 'ver-ofertas-para-minha-regiao');
  };
  var handleClickWishlist = function handleClickWishlist() {
    publish(HEADER_SELECT_CONTENT, 'favoritos');
  };
  var handleClickBag = function handleClickBag() {
    publish(HEADER_SELECT_CONTENT, 'sacola');
    window.location.assign(cartUrl);
  };
  var handleHoverMenuItem = function handleHoverMenuItem(menu) {
    publish(HEADER_IMPRESSION, menu.label);
  };
  var handleClickMenuItem = function handleClickMenuItem(label) {
    publish(HEADER_SELECT_CONTENT, label, 'menu');
  };
  var bagProps = _extends({
    amount: bagCount,
    onClick: handleClickBag
  }, bagIconProps);
  headerProps.data.bag = bagProps;
  return React.createElement(Container, null, React.createElement(StereoHeaderDesktop, _extends({}, headerProps, suggestionsProps, topTermsProps, suggestionLinksProps, {
    customLoginMenu: renderCustomLoginMenu(customLoginMenu == null ? void 0 : customLoginMenu.component, {
      customLoginMenu: customLoginMenu,
      structure: structure
    }),
    onLogoClick: onLogoClick,
    initialValue: term,
    isRendered: isRendered,
    onSuggestItemClick: handleSuggestionClick,
    onProductItemClick: handleProductItemClick,
    onTopTermItemClick: handleTopTermItemClick,
    onHeaderSuggestionLinkClick: handleClickLinkSuggestion,
    onInputOpen: handleOpenInput,
    onInputClose: handleCloseInput,
    onSearch: handleSearch,
    onTypeSearch: handleTypeSearch,
    onZipCodeClick: handleZipCodeClick,
    onClickPopperBtn: handlePopperBtn,
    onClosePopper: handleClosePopper,
    onHorizontalLinksClick: handleClickLinks,
    onClickSearchEvent: handleClickSearch,
    onUnsignedClick: handleUnsignedClick,
    onSignedHover: handleSignedHover,
    popperDisplay: showZipcodePopper,
    onMenuItemClick: handleMenuItemClick,
    onSignedMenuClick: handleSignedMenuClick,
    onHoverZipCode: handleHoverZipCode,
    onClickWishlist: handleClickWishlist,
    onHoverMenuItem: handleHoverMenuItem,
    onClickMenuItem: handleClickMenuItem
  })));
}
process.env.NODE_ENV !== "production" ? HeaderDesktop.propTypes = {
  config: shape({}),
  data: shape({}),
  "static": shape({}),
  structure: shape({
    cookies: shape({
      cartId: string,
      customerId: string
    }).isRequired,
    route: shape({})
  })
} : void 0;
HeaderDesktop.defaultProps = {
  config: {},
  data: {},
  "static": {},
  structure: {
    cookies: {},
    route: {}
  }
};
HeaderDesktop.ssr = true;
HeaderDesktop.displayName = 'HeaderDesktop';
HeaderDesktop.dataSource = {
  categories: {
    query: 'AllCategoriesQuery'
  },
  channel: {
    query: 'ChannelQuery'
  }
};
export default withLayoutProps(HeaderDesktop);